import { render, staticRenderFns } from "./ListaLeads.vue?vue&type=template&id=5c60dbdc"
import script from "./ListaLeads.vue?vue&type=script&lang=js"
export * from "./ListaLeads.vue?vue&type=script&lang=js"
import style0 from "./ListaLeads.vue?vue&type=style&index=0&id=5c60dbdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports